<button class="absolute right-4 top-4 z-10" [matDialogClose]="false">
  <mat-icon class="!w-[15px]" [svgIcon]="'close'"></mat-icon>
</button>
<h2 mat-dialog-title class="text-center !text-[18px] !leading-[24px] !font-bold !mb-0" [innerHTML]="'dialog_cancel_invoice.title' | translate">
</h2>
<mat-dialog-content>
  <hr class="border-t border-white border-opacity-10 mb-3">

  <ng-container class="pointer-events-none" [ngTemplateOutlet]="data.walletHeaderTemplate"></ng-container>

  <button [disabled]="loading()" (click)="cancelInvoice()" mat-ripple class="mt-[46px] !bg-[#C93535] !text-white w-full !min-h-[45px] !text-[18px] flex items-center justify-center gap-2 rounded">
    {{ 'dialog_cancel_invoice.button' | translate }}
  </button>
</mat-dialog-content>
